module Meevo.Plugins.WalkinManager {
    "use strict";

    export class MeevoWalkinManagerEditor implements angular.IDirective {
        restrict = "E";
        
        templateUrl = "app/plugins/walkinManager/walkinManagerEditorTemplate.html";

        constructor(
            private $filter: angular.IFilterService,
            private $mdSidenav: any,
            private $rootScope: ng.IRootScopeService,
            private editorService: any) {
            }

        link: ng.IDirectiveLinkFn  = (scope: any, element: JQuery, attrs: angular.IAttributes) => {
            
        }

        static factory(): angular.IDirectiveFactory {
            let directive = ($filter, $mdSidenav, $rootScope, editorService) => {
                return new MeevoWalkinManagerEditor($filter, $mdSidenav, $rootScope, editorService);
            };

            directive.$inject = ["$filter", "$mdSidenav", "$rootScope", "AppointmentEditorService"];

            return directive;
        }
    }

    angular.module("meevo.plugins.walkinManager")
        .directive("walkinManagerEditor", MeevoWalkinManagerEditor.factory());
}